/* eslint-disable */
// @ts-nocheck
/*
 * Source: https://github.com/uxitten/xwiper
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var defaults = {
    threshold: 50,
    passive: false,
};
var Xwiper = /** @class */ (function () {
    function Xwiper(element, options) {
        if (options === void 0) { options = {}; }
        this.options = __assign(__assign({}, defaults), options);
        this.element = null;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchEndX = 0;
        this.touchEndY = 0;
        this.onSwipeLeftAgent = null;
        this.onSwipeRightAgent = null;
        this.onSwipeUpAgent = null;
        this.onSwipeDownAgent = null;
        this.onTapAgent = null;
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onSwipeLeft = this.onSwipeLeft.bind(this);
        this.onSwipeRight = this.onSwipeRight.bind(this);
        this.onSwipeUp = this.onSwipeUp.bind(this);
        this.onSwipeDown = this.onSwipeDown.bind(this);
        this.onTap = this.onTap.bind(this);
        this.destroy = this.destroy.bind(this);
        this.handleGesture = this.handleGesture.bind(this);
        var eventOptions = this.options.passive ? { passive: true } : false;
        this.element =
            element instanceof EventTarget
                ? element
                : document.querySelector(element);
        this.element.addEventListener('touchstart', this.onTouchStart, eventOptions);
        this.element.addEventListener('touchend', this.onTouchEnd, eventOptions);
    }
    Xwiper.prototype.onTouchStart = function (event) {
        this.touchStartX = event.changedTouches[0].screenX;
        this.touchStartY = event.changedTouches[0].screenY;
    };
    Xwiper.prototype.onTouchEnd = function (event) {
        this.touchEndX = event.changedTouches[0].screenX;
        this.touchEndY = event.changedTouches[0].screenY;
        this.handleGesture();
    };
    Xwiper.prototype.onSwipeLeft = function (func) {
        this.onSwipeLeftAgent = func;
    };
    Xwiper.prototype.onSwipeRight = function (func) {
        this.onSwipeRightAgent = func;
    };
    Xwiper.prototype.onSwipeUp = function (func) {
        this.onSwipeUpAgent = func;
    };
    Xwiper.prototype.onSwipeDown = function (func) {
        this.onSwipeDownAgent = func;
    };
    Xwiper.prototype.onTap = function (func) {
        this.onTapAgent = func;
    };
    Xwiper.prototype.destroy = function () {
        this.element.removeEventListener('touchstart', this.onTouchStart);
        this.element.removeEventListener('touchend', this.onTouchEnd);
    };
    Xwiper.prototype.handleGesture = function () {
        /**
         * swiped left
         */
        if (this.touchEndX + this.options.threshold <= this.touchStartX) {
            this.onSwipeLeftAgent && this.onSwipeLeftAgent();
            return 'swiped left';
        }
        /**
         * swiped right
         */
        if (this.touchEndX - this.options.threshold >= this.touchStartX) {
            this.onSwipeRightAgent && this.onSwipeRightAgent();
            return 'swiped right';
        }
        /**
         * swiped up
         */
        if (this.touchEndY + this.options.threshold <= this.touchStartY) {
            this.onSwipeUpAgent && this.onSwipeUpAgent();
            return 'swiped up';
        }
        /**
         * swiped down
         */
        if (this.touchEndY - this.options.threshold >= this.touchStartY) {
            this.onSwipeDownAgent && this.onSwipeDownAgent();
            return 'swiped down';
        }
        /**
         * tap
         */
        if (this.touchEndY === this.touchStartY) {
            this.onTapAgent && this.onTapAgent();
            return 'tap';
        }
    };
    return Xwiper;
}());
export default Xwiper;
